export default {
  "dpu": {
    "Usage": "Usage",
    "dpuUsage": "{dpuAmount} {dpus}",
    "dpuLimit": " / {limit} DPUs",
    "totalStorageUsed": "{totalStorageUsed} {showGB}",
    "totalStorageCapacity": " / {totalStorageCapacity} GB",
    "dpuReset": "Resets in {daysLeft} days",
    "dpuNextBilling": "Resets next billing cycle",
    "dpuError": "Unable to calculate usage.",
    "dpuSupport": "Please contact our support team"
  }
};
